import React from "react";
import { TableFilterSelectType } from "./table-filter/SelectTableFilter";
import { tableFilters } from "./table-filter";
import { TableFilterDateRangeType } from "./table-filter/DateRangeTableFilter";
import { QueryFilterValue } from "../types";

export type TableFilterProps = {
  filter: TableFilterType;
  onFilterChange: (filterValue: QueryFilterValue) => void;
};

export type TableFilterType = TableFilterSelectType | TableFilterDateRangeType;

export const TableFilter = (props: TableFilterProps) => {
  const FilterComponent = tableFilters[props.filter.type];

  if (!FilterComponent) {
    return null;
  }

  // @ts-ignore
  return <FilterComponent {...props} />;
};
